import React from 'react'
import Navbar from './components/Navbar'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Home from './pages/Home';
import About from './pages/About';
import Portfolio from './pages/Portfolio';
import Footer from './components/Footer';

const Router = ()=>{
  return(
    <BrowserRouter>
    <Navbar/>
    <Routes>
      <Route path='/'>
        <Route index element={<Home/>} />
        <Route path='/about' element={<About/>} />
        <Route path='/portfolio' element={<Portfolio/>} />
      </Route>
    </Routes>
    <Footer/>
    </BrowserRouter>
  );
}
function App() {
  return (
    <div className='bg-dark w-screen h-screen overflow-x-hidden'>
       <Router/>
    </div>
  )
}

export default App